import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import {Link} from 'react-router-dom'

const useStyles = makeStyles(theme => ({
	root: {
		'& .logo-icon': {
			width: 100,
			height: "auto",
			transition: theme.transitions.create(['width', 'height'], {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		},
		'& .react-badge, & .logo-text': {
			transition: theme.transitions.create('opacity', {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		}
	},
	reactBadge: {
		backgroundColor: '#121212',
		color: '#61DAFB'
	}
}));

function Logo() {
	const classes = useStyles();

	return (
		<Link to={'/'}>
			<div className={clsx(classes.root, 'flex items-center')}>
				<img className="logo-icon" src={process.env.PUBLIC_URL + "assets/images/logos/logo.png"} alt="logo" width='100%' height='100%' />
			</div>
		</Link>
	);
}

export default Logo;
